import Layout from "@/components/feature/Layout";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { useState } from "react";
import { faqItems } from "@/mocks/faqItems";

function Faq() {
  const [openId, setOpenId] = useState<string>(faqItems[0].id);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <Layout>
      <title>嘿咻嘿咻漫画常见问题 - 剧情、结局与阅读指南</title>
      <meta
        name="description"
        content="嘿咻嘿咻漫画常见问题解答：故事内容、结局走向、入坑指南、阅读体验与番外信息，一站式解答你的追更疑问。"
      />
      <meta
        name="keywords"
        content="嘿咻嘿咻漫画,常见问题,追更指南,结局走向,阅读体验"
      />
      <link rel="canonical" href="https://characterz2.github.io/faq" />
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <section className="border-b border-background-200/70 bg-background-100">
        <div className="mx-auto w-full max-w-3xl px-4 py-10 md:px-6 md:py-14">
          <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "常见问题" }]} />
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <i className="ri-question-line"></i> 常见问题
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            追更途中，你想问的都在这里
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            关于嘿咻嘿咻漫画的故事内容、结局走向与阅读体验，整理了读者最常问的问题与解答。没有找到想要的？欢迎到关于我们页面留言。
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-3xl px-4 py-12 md:px-6 md:py-16">
        <div className="divide-y divide-background-200/70 rounded-lg border border-background-200/70 bg-background-50">
          {faqItems.map((f) => {
            const isOpen = openId === f.id;
            return (
              <div key={f.id}>
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? "" : f.id)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left"
                >
                  <h2 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {f.q}
                  </h2>
                  <span
                    className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-transform ${isOpen ? "rotate-45" : ""}`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-6">
                    <p className="text-sm leading-7 text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-8 flex flex-col items-center gap-3 rounded-lg bg-background-100 p-6 text-center">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-customer-service-2-line text-lg"></i>
          </span>
          <h3 className="font-heading text-lg font-bold text-foreground-950">还有其它问题？</h3>
          <p className="max-w-md text-sm text-foreground-600">
            没找到答案的话，可以通过关于我们页面的邮箱与我们联系，我们会尽力帮你解答。
          </p>
        </div>
      </section>
    </Layout>
  );
}

export default Faq;